import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NewNotificationIcon } from '../Common/Icons';
import { Badge } from 'antd';
import { useMainContext } from '../../MainContext';
import {
  getNotificationMiniBannerMessage,
  updateNotificationMiniBanner,
} from '@vantiva-sa/homesight_humaui/Store/notificationStore';
import { NavigationKeys, WSMessageTypes } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const NotificationMiniBanner = ({ readOnly, isSelected, searchParams }) => {
  const trans = useSelector(translator);
  const dispatch = useDispatch();
  const { newNotificationCount, fetchNotifications, navigationGuard } = useMainContext();
  const navigate = useNavigate();
  const message = useSelector(getNotificationMiniBannerMessage);
  const [notification, setNotification] = useState(null);
  const currentUser = useSelector(getCurrentUser);

  useEffect(() => {
    // Fetch notifications when there is a websocket message
    if (message) {
      fetchNotifications();
    }
  }, [message]);

  const handleEventMessage = (mMessage) => {
    const event = mMessage?.message?.schedule_event;
    if (event == null) return;
    if (event.action?.includes('delete')) {
      if (event.schedule_eventuuid === notification?.schedule_eventuuid) {
        handleCancel();
      }
      return;
    } else setNotification(mMessage);
  };

  const handleContactMessage = (mMessage) => {
    const contact = mMessage?.message;
    if (!contact || contact.action?.includes('deleted') || contact.action?.includes('delete'))
      return;
    else if (contact.useruuid !== currentUser.useruuid) {
      setNotification(mMessage);
    }
  };

  useEffect(() => {
    if (message == null) return;
    if (message.message_type === WSMessageTypes.calendar) handleEventMessage(message);
    else if (message.message_type === WSMessageTypes.contact) handleContactMessage(message);
  }, [message]);

  const handleCancel = () => {
    setNotification(null);
    dispatch(updateNotificationMiniBanner(null));
  };

  const bellIcon = (
    <div className="flex-align-center" title={trans('NOTIFICATIONS')}>
      <Badge className="notification-count" dot={newNotificationCount > 0} offset={[-11, 10]}>
        <NewNotificationIcon
          style={{
            height: '30px',
            width: '30px',
            fill: isSelected ? '#3fa9f5' : '#113E57',
            stroke: 'none',
          }}
        />
      </Badge>
    </div>
  );
  const renderBellIcon = readOnly ? (
    bellIcon
  ) : (
    <Link
      to={{
        pathname: '/' + NavigationKeys.notification,
        search: '?' + searchParams(),
      }}
      onClick={(e) => {
        if (!navigationGuard) return;
        e.preventDefault();
        navigationGuard(() =>
          navigate('/' + NavigationKeys.notification + '?' + searchParams())
        );
      }}
    >
      {bellIcon}
    </Link>
  );

  return <div className="notification-mini-banner-wrapper">{renderBellIcon}</div>;
};

NotificationMiniBanner.propTypes = {
  readOnly: PropTypes.bool /* disable any clicks */,
};

export default NotificationMiniBanner;
